import React, { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import qs from 'query-string';

import { NotificationManager } from '@atlas/core';
import { Button, DefaultPopup, HeaderTitle, Icon, Input } from '@atlas/ui';

import PaymentMethodItem from 'src/components/ClientProfile/PaymentTab/PaymentMethodItem';

const SpeiDepositPopup = ({ data = {}, id }) => {
  const { paymentMethod, redirectUrl } = data;
  const { amount, clabe } = qs.parse(redirectUrl);
  const [userClabe, setUserClabe] = useState(clabe);
  const [isActiveInput, setIsActiveInput] = useState(false);
  const amountValue = useMemo(
    () => parseInt(typeof amount === 'string' ? amount : amount[0]),
    [amount],
  );

  const copyToClipboard = async text => {
    await navigator.clipboard.writeText(text);
    NotificationManager.notify({
      message: 'copied_data',
      status: 'success',
      type: 'notification',
    });
  };

  const handleClose = useCallback(() => {
    NotificationManager.removeNotification(id);
  }, [id]);

  return (
    <DefaultPopup
      className="spei-modal"
      headerTitle="deposit"
      headerTitlePosition="left"
      onClose={handleClose}
    >
      <HeaderTitle className="block-big popup-payment-method">
        <PaymentMethodItem amount={amountValue} paymentMethod={paymentMethod} showAmount />
      </HeaderTitle>
      <div className="popup-content">
        <div className="popup-input-container">
          <Input
            active={isActiveInput === 'deposit_clabe'}
            className="popup-input"
            label="deposit_clabe"
            onBlur={() => setIsActiveInput(false)}
            onChange={e => setUserClabe(e.target.value)}
            onFocus={() => setIsActiveInput('deposit_clabe')}
            value={userClabe}
          />
          <div
            className="popup-input-button"
            onClick={() => copyToClipboard(userClabe)}
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                copyToClipboard(userClabe);
              }
            }}
            role="button"
            tabIndex={0}
          >
            <Icon name="copy" />
          </div>
        </div>
      </div>

      <div className="popup__footer">
        <Button className="primary big block" label="ok" onClick={handleClose} />
      </div>
    </DefaultPopup>
  );
};

SpeiDepositPopup.propTypes = {
  data: PropTypes.object,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default SpeiDepositPopup;
